import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import {
  MDBBadge,
  MDBBtn,
  MDBChip,
  MDBDatatable,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBTextArea,
  MDBAlert,
  MDBRadio,
  MDBInput,
  MDBCheckbox
} from "mdb-react-ui-kit";

import { browserName, browserVersion } from "react-device-detect";
import { useLocation, useNavigate } from "react-router";
import Popup from "../components/Popup";
import CreateMember from "../components/createMember";
import LogATime from "../components/logatime";
import SubPopup from "../components/supPopup";
import { sendCheckInQrCode, activateMemberShip, getMemberTransactions, logEvent, membersessions, suspendMemberShip, getWhatsAppHistory, updateMemberDNDvalue, downloadcheckinQrCode, getcheckinQrCode, getPlans, getGuestPassHistory, getGuestPassBalance, getSessionSharingHistory, getGymPlansList, getGymAddonsList, getGBussinessInfo } from "../services/apiServices";
import Payments from "./Payments";
import ReceiptPrint from "./ReicptPrint";
import EditMemberShip from "../components/editMembership";
import PageError from "./PageError";
import TransactionDetails from "../components/TransactionDetails";
import { format, parseISO } from "date-fns";
import { formatDate, formatDateTimeWithTZ, formatTime } from '../utils/DateFormat';
import defaultImg from "./../components/images/defaultPerson.png";
import { BasePlanName, getPlanAndSubplan, resolvePlanAndSubplan } from "../utils/BasePlanName";
import { useAnalytics } from "../hooks/useAnalytics";

import { useAccess } from "../context/AccessContext";
import ChangePlanModal from "./ChangePlanModal";

export default function MDetails(props) {
  const { trackButtonClick } = useAnalytics();
  const [centredModal, setCentredModal] = useState(false);
  const toggleOpen = () => setCentredModal(!centredModal);
  const [mPData, setMPData] = useState({
    columns: ["S.no", "Plan Name", "Validity", "Expires On"],
    rows: [],
  });
  const [token, setToken] = useState(null)
  const [logtimeShow, setLogtimeShow] = useState(false);
  const [selData, setSelData] = useState(false);
  const [value, setvalue] = useState("");
  const [apiError, setApiError] = useState(false);
  const [EditMembPopup, setEditMembPopup] = useState()
  const [valuee, setValuee] = useState(-1);
  const [editTrans, seteditTrans] = useState();
  const [selectedTrans, setSelectedTrans] = useState()
  const [flag, setFlag] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [isTransOpen, setIsTransOpen] = useState(false);
  const [mId, setMId] = useState(null);
  const [basicModal3, setBasicModal3] = useState(false);
  const [basicModal4, setBasicModal4] = useState(false);
  const [basicModal5, setBasicModal5] = useState(false);
  const toggleOpen3 = () => setBasicModal3(!basicModal3);
  const toggleOpen4 = () => setBasicModal4(!basicModal4);
  const toggleOpen5 = () => setBasicModal4(!basicModal5);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [error, setError] = useState("")

  const [selectedMemberData,setSelectedMemberData] = useState(null)

  const { loading, handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("memberdetails")
  console.log(roleAccess, 'roleAccess');
  // const [roleAccess, setRoleAccess] = useState({})
  // useEffect(async () => {
  //   const roleAccess = await handlePageAccess("memberdetails")

  //   setRoleAccess(roleAccess)
  // }, [])

  const addonColumns = [
    "S.no",
    "Addon Name",
    "Transaction Date",
    "Start Date",
    "End Date",
    "Status",
    "Edit"
  ];
  console.log(roleAccess, 'roleAccess');



  // if (roleAccess?.editmembership == 1) {
  //   addonColumns.push("Edit");
  // }


  const [mAData, setMAData] = useState({
    columns: addonColumns,
    rows: [],
  });
  const [mPMData, setPMData] = useState({
    columns: [
      "S.no",
      "Token",
      "Transaction ID",
      "Date",
      "Payment Mode",
      "Total Amount",
      "Paid",
      "Balance",
    ],
    rows: [],
  });
  const [mATData, setMATData] = useState({
    columns: ["S.no", "Date", "Check-In Time", "Check-Out Time", "Check-In Source"],
    rows: [],
  });
  const [expiresin, setExpiresin] = useState(new Date().toLocaleDateString());
  const [allData, setALLData] = useState([]);
  const [transDate, setTransDate] = useState(new Date())
  const [basicActive, setBasicActive] = useState("tab1");
  const [DNDToggle, setDNDToggle] = useState(false)
  const [selectedOption, setSelectedOption] = useState("Email");
  const [emailList, setEmailList] = useState("");
  const [numberList, setNumberList] = useState("");
  const [checkedOption, setCheckedOption] = useState(true)
  const [historyPopup, SetHistoryPopup] = useState(false)
  const [plans, setPlans] = useState("");
  const [loadingGuestPass, setLoadingGuestPass] = useState(false);
  const [guestPassHistory, setGuestPassHistory] = useState({
    columns: [
      "S.no",
      "Name",
      "Phone Number",
      "Status",
      "Check-In Date",
      "Plan",

    ],
    rows: [],
  });

  const [allPlans, setAllPlans] = useState([]);
  const [allAddons, setAllAddons] = useState([]);
  const [businessTax, setBusinessTax] = useState(null);

  const [loadingSessionSharing, setLoadingSessionSharing] = useState(false);

  const [sessionSharingHistory, setSessionSharingHistory] = useState({
    columns: [
      "S.no",
      "Name",
      "Phone Number",
      "Check-In Date",
      "Plan",
      // "Status"
    ],
    rows: [],
  });

  function handleTransdate(date) {
    console.log("in transdetails handleTransDate", date);
    setTransDate(date)
  }
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  function createMemberCallback(e, newMember, flag, updates) {
    togglePopup();
    setError(flag)

    fetchData();

  }


  async function activateFunction(e) {
    e.preventDefault();
    let id = location.state._id;
    await activateMemberShip(id);
    let ip = localStorage.getItem("ipaddress");
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let Eventtype = "Plan";
    let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
    let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
    let flag = "Plan Activation Successfull";
    await trackButtonClick("MDetails", "Member_Activation", "staff", {});

    await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
    window.location.reload();
  }

  function openEditForm(e) {
    e.stopPropagation();
    setMId((allData.length > 0 && allData[0]._id) ? allData[0]._id : -1)
    togglePopup();
  }
  function onsubmit() {
    setFlag(1);
  }
  console.log(EditMembPopup);
  function updatePopupFunction(e, data) {
    e.preventDefault();
    console.log(data);
    seteditTrans(data);
  }


  function ViewHistory(e, data) {
    e.preventDefault();
    setSelectedTrans(data)
    SetHistoryPopup(true)
  }

  const navigate = useNavigate();
  const location = useLocation();

  const [openPayment, setOpenPayment] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [wtsappHistory, setWtsappHistory] = useState([])
  const [tId, setTId] = useState(null);
  const [transid, settransid] = useState("")
  const [Rid, setRid] = useState(null);
const [showChangePlan, setShowChangePlan] = useState(false);
const [changeType, setChangeType] = useState("plan");

const openChangePlanModal = (transaction, type = "plan") => {
  setSelectedMemberData(transaction);
  setChangeType(type);  
  setShowChangePlan(true);
};



  const toggleTransPopup = (event, tId, token, _id, id) => {
    event.preventDefault();
    setTId(tId);
    setToken(token)
    setIsTransOpen(!isTransOpen);
    setRid(id);
    settransid(_id)
  };
  const closeTransPopup = () => {
    if (isTransOpen) {
      setIsTransOpen(false);
    }
  };

  const [sessionInfo, setSessionInfo] = useState([])
  //setGuestInfo
  console.log("sessionInfo", sessionInfo)

  const [guestInfo, setGuestInfo] = useState([])

  const [sessionHistory, setSessionHistory] = useState([]);
  useEffect(() => {
    async function fetchPlans() {
      try {
        let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";

        const planResponse = await getPlans(gymid);

        if (!planResponse || planResponse === "false") {
          setApiError(true);
        } else {
          const plans = await planResponse.json();
          if (plans) {
            setPlans(plans);
          }
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
        setApiError(true);
      }
    }

    fetchPlans();
  }, []);

  async function fetchData() {

    setFlag(0);
    console.log(location);
    setDNDToggle(location.state?.isDND)

    fetchGuestPassHistory(location.state._id);
    fetchSessionSharingHistory(location.state._id);

    const response = await getMemberTransactions(location.state?._id);
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
      return;
    }
    const membersData = await response.json();
    console.log(membersData);
    setALLData(membersData);
    let data = membersData[0];

    // Update location.state with the latest data, handling empty values
    location.state.fname = data.fname || "";
    location.state.lname = data.lname || "";
    location.state.email = data.email || "";
    location.state.number = data.number || "";
    location.state.sex = data.sex || "";
    location.state.height = data.height || "";
    location.state.weight = data.weight || "";
    location.state.bloodgroup = data.bloodgroup || "";
    location.state.country = data.country || "";
    location.state.city = data.city || "";
    location.state.address = data.address || "";
    location.state.isDND = data.isDND || false;


    if (location.state?._id) {
      await fetchGuestPassHistory(location.state._id);
    }



    const resp = await membersessions(location.state?._id);

    if (!resp) {
      return;
    }
    if (resp === "false") {
      setApiError(true)
      return;
    }
    const sessionData = await resp.json();
    console.log(sessionData);

    setSessionInfo(sessionData)



    const responsee = await getGuestPassBalance(location.state?._id);

    if (!responsee) {
      return;
    }
    if (responsee === "false") {
      setApiError(true)
      return;
    }
    const gustData = await responsee.json();
    console.log(gustData);
    setGuestInfo(gustData)



    const res = await getWhatsAppHistory(location.state?._id);

    try {

      const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
      const gymid = loggedUserInfo.gymid || "";

      // Fetch plans first
      const planResponse = await getPlans(gymid);

      if (!planResponse || planResponse === "false") {
        throw new Error("Failed to fetch plans");
      }

      const plans = await planResponse.json();
      if (!plans) {
        throw new Error("No plans data received");
      }
      setPlans(plans);


      const response = await getMemberTransactions(location.state?._id);
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
        return;
      }
      const membersData = await response.json();
      console.log(membersData);
      setALLData(membersData);


      const resp = await membersessions(location.state?._id);

      if (!resp) {

        return;
      }
      if (resp === "false") {
        setApiError(true)
        return;
      }
      const sessionData = await resp.json();
      console.log(sessionData);



      const res = await getWhatsAppHistory(location.state?._id);

      if (!res) {

        return;
      }
      if (res === "false") {
        setApiError(true)
        return;
      }



try {
  const storedUser = localStorage.getItem("loggedUserInfo");
  if (!storedUser) return;

  const { gymid } = JSON.parse(storedUser);

  const response = await getGymPlansList(gymid);

  if (!response) return;

  if (response === "false") {
    setApiError(true);
    return;
  }

  const allplan = await response.json();

  const expandedPlans = allplan.flatMap(plan => {
    const mainPlan = { ...plan, type: "plan" };

    const subPlans = (plan.subplans || []).map(sub => ({
      ...sub,
      type: "plan",
    }));

    return [mainPlan, ...subPlans];
  });

  // set state here if needed
  setAllPlans(expandedPlans);

} catch (error) {
  console.error("Error fetching plans:", error);
  setApiError(true);
}



    try {
      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      const response = await getGymAddonsList(gymid);
      if (response && response !== "false") {
        const addonsList = await response.json();
        // Filter only active addons
        const activeAddons = addonsList.filter(addon => addon.enable === true);
        setAllAddons(activeAddons);
      }
    } catch (err) {
      console.error("Error fetching addons:", err);
      setError("Failed to load addons");
    }
  




    try {
      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      const response = await getGBussinessInfo(gymid);
      
      if (response && response !== "false") {
        const data = await response.json();
        setBusinessTax(data);
      }
    } catch (err) {
      console.error("Error fetching tax info:", err);
      setError("Failed to load tax information");
    }




      const responsee = await getGuestPassBalance(location.state?._id);

      if (!responsee) {
        return;
      }
      if (responsee === "false") {
        setApiError(true)
        return;
      }
      const gustData = await responsee.json();
      console.log(gustData);

      const whatsappHistory = await res.json();
      // console.log(whatsappHistory, '999999999000000000000000000000');
      setWtsappHistory(whatsappHistory)

      const data = membersData[0]
      location.state.fname = data.fname
      location.state.lname = data.lname
      location.state.email = data.email
      location.state.number = data.number
      location.state.sex = data.sex
      location.state.height = data.height
      location.state.bloodgroup = data.bloodgroup
      location.state.isDND = data.isDND
      setDNDToggle(data.isDND)
      console.log(membersData);
      // localStorage.setItem("memberm_filter", JSON.stringify(location.state.filters));
      if (location.state.return === "mmanager") {
        localStorage.setItem("memberm_filter", JSON.stringify({
          filters: location.state.filters,
          dashboardFID: location.state.anotherColumn,
          dashboardFfdate: location.state.Date11,
          dashboardFtdate: location.state.Date22,
        }));
      }

      if (!membersData) {

        navigate("/");
        return;
      }



      console.log(plansInfo, 'plansInfo');
      const columns = [
        "S.no",
        "Plan Name",
        "Transaction Date",
        "Start Date",
        "End Date",
        "Session(s)",
        "Balance Session(s)",
        "Balance passes",
        "Status",
        "Actions"
      ];

      // if (roleAccess?.editmembership == 1) {
      //   columns.push("Actions");
      // }

      let ship_data = {
        columns: columns,
        rows: [],
      };
      console.log(roleAccess, roleAccess?.editmembership, 'roleAccess?.editmembership ');

      let index_m = 0;
      console.log(membersData);
      membersData[0].trans.forEach((data, index) => {
        let PauseObj = (data.pause && data.pause.length > 0) ? data.pause.sort((a, b) => b.sno - a.sno)[0] : {};
        let filterExtend = data.extend && data.extend.length > 0 ? data.extend.filter((obj) => {
          let oldEndDate = new Date(obj.oldEndDate);
          let newEndDate = new Date(obj.newEndDate);
          let currentDate = new Date();
          return oldEndDate <= currentDate && currentDate <= newEndDate;
        }) : [];

        if (data.isplan === "1") {
          index_m++;
          const session = sessionData.length > 0 && sessionData.filter(item => item.transid === data._id)
          // const sessionstatus=session[0].balsessions==0
          // const plandata = membersData[0].plan.filter((item) => item._id == data.itemid).length > 0 ? (membersData[0].plan.filter((item) => item._id == data.itemid)[0]) : []
          // console.log(plandata);
          console.log(session, 'session');

          // let guestPassBalance = 0;
          // if (gustData && gustData.length > 0) {
          //   // Find the guest info for this specific transaction
          //   const guestPassForTransaction = gustData.find(g => g.transid === data._id);
          //   guestPassBalance = guestPassForTransaction ? guestPassForTransaction.balguestpass || 0 : 0;
          // }


          let guestPassBalance = "--";

          if (gustData && gustData.length > 0) {
            const guestPassForTransaction = gustData.find(g => g.transid === data._id);

            if (guestPassForTransaction) {
              guestPassBalance =
                guestPassForTransaction.balguestpass !== undefined &&
                  guestPassForTransaction.balguestpass !== null
                  ? guestPassForTransaction.balguestpass
                  : 0;
            }
          }



          const planItem =
            membersData[0].plan.find(item => item._id === data.itemid) ||
            membersData[0].subplan.find(item => item._id === data.itemid);
          const planDisplayName = planItem
            ? (planItem.baseplan
              ? `${BasePlanName(plans, planItem?.baseplan)} - ${planItem?.name}`
              : planItem.name
            )
            : "";
          let rarray = [];
          rarray.push(index_m);

          rarray.push(planDisplayName);
          rarray.push(
            formatDateTimeWithTZ(data.createdAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            })
          );
          rarray.push(
            formatDateTimeWithTZ(data.startdate).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            })
          );
          rarray.push(
            formatDateTimeWithTZ(data.expirydate).toLocaleString("en-IN", {
            })
          );
          rarray.push(
            session && session.length > 0 ? session[0].totalsessions : "--"
          );
          rarray.push(
            session && session.length > 0 ? session[0].balsessions : "--"
          );


          rarray.push(guestPassBalance);



          rarray.push(<div className="title">{
            (PauseObj && PauseObj.resume) ? "paused" :
              (filterExtend.length > 0 ? "extend" :
                ((session && session.length > 0 && session[0].balsessions <= 0) || (new Date(data.expirydate) < new Date()) ? "Inactive" : "Active"))}
          </div>);
      

const actionsColumn = (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      minWidth: "150px",
      justifyContent: "flex-start",
    }}
  >



    {/* Edit icon - conditional based on role */}
    {roleAccess?.editmembership == 1 && (
      (plansInfo != null && plansInfo?.feature?.editmembership) ? (
        !membersData[0]?.issuspend ? (
          <MDBIcon
            fas
            icon="edit"
            style={{ cursor: "pointer" }}
            onClick={(e) => updatePopupFunction(e, data)}
          />
        ) : (
          <MDBIcon fas icon="edit" style={{ opacity: 0.5 }} />
        )
      ) : (
        <MDBIcon
          fas
          icon="edit"
          style={{ cursor: "pointer" }}
          onClick={() =>
            setError(
              "You are unable to edit this feature. Please upgrade your subscription plan to enable it."
            )
          }
        />
      )
    )}
    

    <MDBBtn
   size="md"
      style={{
        whiteSpace: "nowrap", 
        padding: "4px 10px",
      }}
      onClick={() => openChangePlanModal(data)}
    >
      Upgrade Plan
    </MDBBtn>
  </div>
);

rarray.push(actionsColumn);

          ship_data.rows.push(rarray);
        }
      });
      setMPData(ship_data);
      let addons = [];
      let payments = [];

      let totaldue = 0;
      let ptransArr =
        membersData[0].trans.length > 0
          ? membersData[0].trans
          : [];
      console.log(ptransArr);
      const filteredTrans = membersData[0].trans.reduce((acc, current) => {
        // Check if current transaction with the same tId already exists in accumulator
        const existingTrans = acc.find(trans => trans.tId === current.tId);
        if (!existingTrans) {
          // If not, add it to the accumulator
          acc.push(current);
        }
        return acc;
      }, []);
      console.log(filteredTrans);

      ptransArr = ptransArr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      // ptransArr.map((data, index) => {
      filteredTrans.forEach((data, index) => {
        console.log(membersData, membersData[0].addons, data, data.itemid, '99999999999');

        let membership = membersData[0].plan.filter((item) => item._id == data.itemid)
        if (membership.length === 0) {
          membership = membersData[0].addons.filter((item) => item._id == data.itemid)
        }
        console.log(membership);

        let rarray = [];
        rarray.push(index + 1);
        // rarray.push(data.token)
        rarray.push(<button className="button-link link-color" onClick={(event) => toggleTransPopup(event, data.tId, data.token, data._id)}>{data.token ? data.token : data.tId}</button>)

        rarray.push(data.tId);
        rarray.push(
          formatDateTimeWithTZ(data.createdAt).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          })
        );
        rarray.push(
          data.payment.mode === 1 ? (
            "Cash"
          ) : data.payment.mode === 2 ? (
            "Card"
          ) : data.payment.mode === 3 ? (
            "UPI"
          ) : data.payment.mode === 4 ? (
            "Wallet"
          ) : data.payment.mode === 5 ? (
            "Coupon"
          ) : data.payment.mode === -2 ? (
            "Payment Link"
          ) : data.payment.mode === -3 ? (
            "Razorpay"
          ) : data.payment.mode === 6 ? (
            <>
              Multiple <br /> Cash:
              {JSON.parse(data.payment.payinfo).info.cash_amt}
              <br /> Credit Card:{JSON.parse(data.payment.payinfo).info.cc_amt}
              <br /> UPI:
              {JSON.parse(data.payment.payinfo).info.upi_amt +
                "(" +
                JSON.parse(data.payment.payinfo).info.upi_input +
                ")"}
              <br />
              Wallet:{" "}
              {JSON.parse(data.payment.payinfo).info.wallet_amt +
                "(" +
                JSON.parse(data.payment.payinfo).info.wallet_input +
                ")"}
            </>
          ) : data.payment.mode >= 7 ? <>

            {JSON.parse(data.payment.payinfo).info.userpaymethod}
          </> : "Account Payment Type"

        );
        rarray.push(data.payment.totalamount ? "₹" + data.payment.totalamount : "--");
        rarray.push(data.payment.paid ? "₹" + data.payment.paid : "--");
        rarray.push(data.payment.balance !== 0 ?
          <div className="d-flex align-items-center justify-content-end">
            <div className="me-2">
              {data.payment.balance ? "₹" + data.payment.balance : "--"}
            </div>
            <div className="link-color" onClick={(e) => payNow(e, data, membership)}>Pay Now</div>
          </div>
          : (data.payment.balance ? "₹" + data.payment.balance : "--"));
        if (!data.members) {
          totaldue = totaldue - data.payment.paid * 1;
        } else {
          totaldue = totaldue + data.payment.balance * 1;
        }

        payments.push(rarray);
      });
      let index_a = 0;
      // setTotalDue(totaldue);
      membersData[0].trans.forEach((data, index) => {
        if (data.isplan !== "1") {
          index_a++;
          let PauseObj = (data.pause && data.pause.length > 0) ? data.pause.sort((a, b) => b.sno - a.sno)[0] : {};
          let filterExtend = data.extend && data.extend.length > 0 ? data.extend.filter((obj) => {
            let oldEndDate = new Date(obj.oldEndDate);
            let newEndDate = new Date(obj.newEndDate);
            let currentDate = new Date();
            return oldEndDate <= currentDate && currentDate <= newEndDate;
          }) : [];
          let rarray = [];
          rarray.push(index_a);
          rarray.push(membersData[0].addons.length > 0
            && membersData[0].addons.filter((item) => item._id === data.itemid).length > 0
            && membersData[0].addons.filter((item) => item._id === data.itemid)[0].name);
          rarray.push(
            formatDateTimeWithTZ(data.createdAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            })
          );
          rarray.push(
            formatDateTimeWithTZ(data.startdate).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            })
          );
          rarray.push(
            formatDateTimeWithTZ(data.expirydate).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            })
          );
          rarray.push(<div className="title">{
            (PauseObj && PauseObj.resume) ? "paused" :
              (filterExtend.length > 0 ? "extend" :
                (new Date(data.expirydate) > new Date() ? "Active" : "Inactive"))}
          </div>);




const addonActionsColumn = (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      minWidth: "150px",
      justifyContent: "flex-start",
    }}
  >
 
    {roleAccess?.editmembership == 1 && (
      <MDBIcon 
        fas 
        icon="edit" 
        style={{ cursor: "pointer" }} 
        onClick={(e) => !membersData[0].issuspend && updatePopupFunction(e, data)} 
      />
    )}
    
    {/* Change Addon button - always visible */}
    <MDBBtn
   size="md"
      style={{
        whiteSpace: "nowrap",
        padding: "4px 10px",
      }}
      onClick={() => openChangePlanModal(data, "addon")}
    >
      Upgrade Addon
    </MDBBtn>
  </div>
);

if (roleAccess?.editmembership == 1) {
  rarray.push(addonActionsColumn);
} else {

  rarray.push(
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        minWidth: "150px",
        justifyContent: "flex-start",
      }}
    >
      <MDBBtn
  size="md"
          style={{
          whiteSpace: "nowrap",
          padding: "4px 10px",
        }}
        onClick={() => openChangePlanModal(data, "addon")}
      >
        Change Addon
      </MDBBtn>
    </div>
  );
}

    addons.push(rarray);
  }
});
      // mAData.rows = addons;
      setMAData((prevData) => ({
        ...prevData,
        rows: addons,
      }));
      // mPMData.rows = payments;
      setPMData((prevData) => ({
        ...prevData,
        rows: payments,
      }));
      setExpiresin(getExpiryDate(membersData[0]));
      setValuee(location && location.state && location.state.anotherColumn);

    } catch (err) {
      console.error("Unexpected error in fetchData:", err);
      setApiError(true);
    }
  }

  // mATData.rows = attendance;


  // useEffect(() => {
  //   const loadHistory = async () => {
  //     if (basicActive === "tab6" && location.state?._id) {
  //       fetchGuestPassHistory(location.state._id);
  //       fetchSessionSharingHistory(location.state._id);
  //     }
  //   };

  //   loadHistory();
  // }, [basicActive, location.state?._id]);


  const fetchGuestPassHistory = async (memberId) => {
    setLoadingGuestPass(true);
    try {
      const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
      const gymId = loggedUserInfo.gymid || "";

      if (!gymId) {
        console.error("Gym ID not found");
        setLoadingGuestPass(false);
        return;
      }

      // Pass both memberId and gymId to the API function
      const response = await getGuestPassHistory(memberId, gymId);

      if (!response || response === "false") {
        console.error("Failed to fetch guest pass history");
        setGuestPassHistory(prev => ({
          ...prev,
          rows: []
        }));
        setLoadingGuestPass(false);
        return;
      }

      const result = await response.json();
      console.log("GuestPassHistory:", result);


      const passes = result?.data || [];

      // If passes is empty, set empty rows
      if (passes.length === 0) {
        setGuestPassHistory(prev => ({
          ...prev,
          rows: []
        }));
        setLoadingGuestPass(false);
        return;
      }

      const rows = passes?.length > 0 && passes?.map((pass, index) => {


        // Get status with appropriate badge color
        const statusBadge = () => {
          let color = "";
          switch (pass?.status) {

            case "CHECKED_IN": color = "info"; break;

            case "CONVERTED": color = "info"; break;
            default: color = "light";
          }
          return <MDBBadge color={color} light>{pass.status}</MDBBadge>;
        };

        // Format dates safely
        const formatSafeDate = (dateString) => {
          if (!dateString) return "N/A";
          try {
            return formatDateTimeWithTZ(dateString).toLocaleString("en-IN");
          } catch (e) {
            return new Date(dateString).toLocaleDateString("en-IN");
          }
        };

        // Get plan name safely
        const getPlanName = () => {
          if (pass.planname) return pass.planname;
          if (pass.planId?.name) return pass.planId.name;
          return "N/A";
        };


        return [
          index + 1,
          pass?.guestName || "N/A",
          pass?.guestPhone || "N/A",
          pass?.status,
          formatSafeDate(pass.reservedAt),
          getPlanName(),

        ];
      });

      setGuestPassHistory(prev => ({
        ...prev,
        rows: rows
      }));

    } catch (error) {
      console.error("Error in fetchGuestPassHistory:", error);
      setGuestPassHistory(prev => ({
        ...prev,
        rows: []
      }));
    } finally {
      setLoadingGuestPass(false);
    }
  };


  // Add this function to fetch session sharing history
  const fetchSessionSharingHistory = async (memberId) => {
    setLoadingSessionSharing(true);
    try {
      const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
      const gymId = loggedUserInfo.gymid || "";

      if (!gymId) {
        console.error("Gym ID not found");
        setLoadingSessionSharing(false);
        return;
      }

      // You'll need to create this API function
      const response = await getSessionSharingHistory(memberId, gymId);

      if (!response || response === "false") {
        console.error("Failed to fetch session sharing history");
        setSessionSharingHistory(prev => ({
          ...prev,
          rows: []
        }));
        setLoadingSessionSharing(false);
        return;
      }

      const result = await response.json();
      console.log("SessionSharingHistory:", result);

      const shares = result?.data || [];

      if (shares.length === 0) {
        setSessionSharingHistory(prev => ({
          ...prev,
          rows: []
        }));
        setLoadingSessionSharing(false);
        return;
      }

      const rows = shares.map((share) => {
        // Get status with appropriate badge color
        const statusBadge = () => {
          let color = "";
          let statusText = share.status || "SHARED";

          switch (statusText) {
            case "CHECKED_IN":
              color = "success";
              statusText = "Checked In";
              break;
            case "CHECKED_OUT":
              color = "secondary";
              statusText = "Checked Out";
              break;
            case "SHARED":
              color = "warning";
              statusText = "Shared";
              break;
            default:
              color = "info";
          }
          return <MDBBadge color={color} light>{statusText}</MDBBadge>;
        };

        // Format date safely
        const formatSafeDate = (dateString) => {
          if (!dateString) return "N/A";
          try {
            return formatDateTimeWithTZ(dateString).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            });
          } catch (e) {
            return new Date(dateString).toLocaleString("en-IN");
          }
        };

        return [
          share.sno,
          share.guestName || "N/A",
          share.phoneNumber || "N/A",
          formatSafeDate(share.checkInDate),
          share.planName || "N/A",
          // statusBadge()
        ];
      });

      setSessionSharingHistory(prev => ({
        ...prev,
        rows: rows
      }));

    } catch (error) {
      console.error("Error in fetchSessionSharingHistory:", error);
      setSessionSharingHistory(prev => ({
        ...prev,
        rows: []
      }));
    } finally {
      setLoadingSessionSharing(false);
    }
  };


  useEffect(() => {
    let attendance = [];
    allData.length > 0 && allData[0].attendance.length > 0 && allData[0].attendance.forEach((data, index) => {
      let rarray = [];
      rarray.push(index + 1);
      rarray.push(data.intime ? formatDateTimeWithTZ(data.intime) : "NA");
      rarray.push(data.intime ? formatTime(data.intime) : " -- ");
      rarray.push(data.outtime ? formatTime(data.outtime) : " -- ");
      rarray.push(data.viabiometric ? "Biometric" : "Manual");
      attendance.push(rarray);
    });
    setMATData((prevData) => ({
      ...prevData,
      rows: attendance,
    }));
  }, [allData])
  let membership = {};
  if (allData.length > 0 && allData[0].trans.length > 0) {
    const { plan, subplan, addons } = allData[0];

    // Active transactions first
    let membertrans = allData[0].trans
      .filter(
        (obj) =>
          obj.isplan == "1" && new Date() < new Date(obj.expirydate)
      )
      .sort((a, b) => new Date(b.expirydate) - new Date(a.expirydate));

    // All transactions sorted by expiry
    let membertran = allData[0].trans.sort(
      (a, b) => new Date(b.expirydate) - new Date(a.expirydate)
    );

    let latestTran = membertrans.length > 0 ? membertrans[0] : membertran[0];

    if (latestTran) {
      if (plan && plan.length > 0) {
        membership = plan.find((item) => item._id === latestTran.itemid) || {};
        if (membership._id) {
          membership.membershiptype = "plan";
        }
      }

      if ((!membership._id) && subplan && subplan.length > 0) {
        membership = subplan.find((item) => item._id === latestTran.itemid) || {};
        if (membership._id) {
          membership.membershiptype = "plan";
        }
      }

      //  Check in Addons
      if ((!membership._id) && addons && addons.length > 0) {
        membership = addons.find((item) => item._id === latestTran.itemid) || {};
        if (membership._id) {
          membership.membershiptype = "addon";
        }
      }
    }
  }
  console.log(membership)

  function getExpiryDate(data) {
    try {
      console.log(data);
      if (!data.expirydate) return "No Plan";

      let startdate = new Date();
      let enddate = data.expirydate;
      console.log(startdate);
      console.log(enddate);
      let expirydate = new Date(enddate).getTime() - startdate.getTime();
      let cd = 24 * 60 * 60 * 1000;
      console.log(Math.floor(expirydate / cd));
      let exdays = Math.floor(expirydate / cd) + 1;
      return !data.expirydate ? "No Plan Associated" : exdays >= 1
        ? exdays + " Day(s)"
        : data.attendance[0] &&
          new Date(data.attendance[0].intime).getTime() >=
          new Date(enddate).getTime()
          ? "Expired (Overdue)"
          : "Expired";
    } catch (e) {
      console.log("Error :::::::::::::::: " + e);
      return "No Plan";
    }
  }
  function gotohome() {
    cancelThis();
  }

  function cancelThis(event) {
    clearAll();
  }

  function clearAll() {
    setOpenPayment(false);
    setOpenReceipt(false);
  }

  function oncancelpayment() {
    setOpenPayment(false);
    setOpenReceipt(false);
  }

  function preaddUser(dataObj) {
    console.log("preaddUser", dataObj)
    // dataObj = { member, planId, subplanId? }

    localStorage.setItem("preadd_plan", JSON.stringify(dataObj));
    localStorage.setItem("preadd_member", JSON.stringify(dataObj));
    navigate("/home");
  }




  function onPayemntDone(event) {
    setOpenReceipt(true);
  }
  function payNow(e, data, plan) {
    e.preventDefault();
    console.log(data, plan);

    let dueTrans = data
    let balanceamt = data.payment.balance;
    let totalPrice = dueTrans ? dueTrans.payment.totalamount : 0;
    localStorage.setItem(
      "allData",
      JSON.stringify({
        price: balanceamt,
        isplan: 3,
        ref_tId: dueTrans.tId,
        token: data.token,
        totalPrice: totalPrice,
      })
    );
    let planDetails = plan
    const taxIncluded = planDetails && planDetails.length > 0 && planDetails[0].taxcheck === true ? "Included" : "Excluded"
    const taxamounts = dueTrans.payment.taxamounts ? dueTrans.payment.taxamounts : [{ TaxCheck: `${taxIncluded}` }];
    localStorage.setItem("transactionId", dueTrans.tId);
    localStorage.setItem(
      "selItems",
      JSON.stringify([{
        Item: planDetails[0],
        idate: dueTrans.startdate,
        isplan: 3,
        members: [dueTrans.members],
        quantity: 1,
        taxamounts: taxamounts,
        _id: dueTrans.itemid,
        token: data.token,
        ref_tId: dueTrans.tId,
        price: balanceamt,
      }])
    );
    setOpenPayment(true);
  }
  useEffect(() => {
    if (flag === 1 && !loading) {
      fetchData();
    }
  }, [flag, loading]);

  function showInfo(event, page, tInfo) {
    event.preventDefault();
    console.log(page, '999999999999');

    navigate("/" + page, {
    });
  }
  function openLogTime(e, data, value) {
    console.log(data)
    setSelData(data);
    setvalue(value);
    setLogtimeShow(true);
  }
  function closeLogTime() {
    setLogtimeShow(false);
  }
  function checkMember(updates, member) {
    // window.location.reload();
    setFlag(1)
    setLogtimeShow(false)
  }
  console.log(allData);
  const [reason, setReason] = useState("")
  const [errors, setErrors] = useState("");

  async function suspendSubmitFunction(e) {
    e.preventDefault();
    let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
    let ip = localStorage.getItem("ipaddress");
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let Eventtype = "Membership";
    let username1 = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : ""; if (reason !== "") {
      let id = location.state._id;
      await suspendMemberShip(id);
      let flag = `Member Suspend Successfull (${location.state.fname} ${location.state.lname})`;
      await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
      await trackButtonClick("MDetails", "Member_Suspend", "staff", {});
      window.location.reload();
    } else { setErrors("Field can't be empty.") }
  }
  const handlerReason = (e) => {
    setReason(e.target.value)
  }
  const handleReload = () => {
    window.location.reload();
  }

  const [basicData, setBasicData] = useState({
    columns: [],
    rows: [],
  });


  /**
  * mappingTemplate function is used for map the varibles .
  * created by vamshi
  * @function
  * 
  * @description
  * This mappingTemplate function has been create on [16-7-2024] used to map the template varibles with the application values.
  */
  const mappingTemplate = (params, template) => {
    let result = template;
    params.forEach(param => {
      if (param.name && param.value) {
        const placeholder = `{{${param.name}}}`;
        const boldPlaceholder = `*${placeholder}*`;
        if (result.includes(boldPlaceholder)) {
          result = result.replace(boldPlaceholder, `<b>${param.value}</b>`);
        } else {
          result = result.replace(placeholder, param.value);
        }
      }
    });
    return result;
  };

  useEffect(() => {
    const generateRow = (item, snumber) => {
      const memberprams = item.templatevalues.filter(data => data.memberid == location.state._id);
      let message = item.template;

      if (memberprams.length > 0) {
        message = mappingTemplate(memberprams[0].customParams, item.template);
      }

      return [
        snumber,
        item.campainname,
        item.updatedAt ? formatDateTimeWithTZ(item.updatedAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) : "NA",
        item.wtscategory !== "campaign" ? "Notification" : "Campaign",
        item.templatename,
        <div className='m-0 ms-2' dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, '<br />') }}></div>
      ];
    };

    const popupRow = wtsappHistory?.length > 0
      ? wtsappHistory.map((item, index) => generateRow(item, index + 1))
      : [];

    setBasicData({
      columns: ["S.no", 'Campain Name', 'Date', "category", "templatename", 'Message'],
      rows: popupRow
    });
  }, [wtsappHistory]);
  // const []

  /**
  * handleDNDToggle function is used to handle the DND toggle .
  * created by vamshi
  * @function
  * 
  * @description
  * This handleDNDToggle function has been create on [17-7-2024] used set the DND toggle state.
  */
  const handleDNDToggle = async (e) => {
    e.preventDefault()
    const update = {
      isDND: !DNDToggle,
      id: location.state._id
    }
    await updateMemberDNDvalue(location.state._id, update);
    setDNDToggle(!DNDToggle)
  }
  let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
  // let planwithsession = plansInfo === null || (plansInfo.planFeature && plansInfo.planFeature.planswithsessionslimit)
  const [qrcodeUrl, setQrcodeUrl] = useState(location.state?.qrcheckinlink)
  const handleQRcodepopup = async () => {
    if (location.state?.qrcheckinlink) {
      setQrcodeUrl(location.state?.qrcheckinlink)
    } else {
      const update = {
        mId: location.state._id,
        bId: location.state.bId,
      }
      const res = await getcheckinQrCode(location.state._id, update)
      if (!res) {

        return;
      }
      if (res === "false") {
        setApiError(true)
        return;
      }
      const urldata = await res.json();
      console.log(urldata, 'urldata');

      setQrcodeUrl(urldata?.url
        ? urldata?.url
        : null)
    }

    toggleOpen4()
  }
  const handleQrCode = async () => {
    let recipients = [];

    if (selectedOption === "Email") {

      recipients = [
        checkedOption ? allData?.[0]?.email : "",
        ...emailList.split(",").map((email) => email.trim()),
      ].filter(Boolean);
    } else {

      recipients = [
        checkedOption ? allData?.[0]?.number : "",
        ...numberList.split(",").map((num) => num.trim()),
      ].filter(Boolean);
    }

    console.log(`Sending ${selectedOption} to:`, recipients);
    if (!recipients && recipients.length > 0) {
      setError(`${selectedOption} is required to send the QR code.`);
      return;
    }

    const updates = {
      mId: allData?.[0]?._id,
      bId: allData?.[0]?.bId,
      type: selectedOption,
      recipients: recipients
    };
    // console.log("Button clicked with updates:", updates);
    setIsButtonDisabled(true);

    try {
      if (recipients.length > 0) {
        const response = await sendCheckInQrCode(allData?.[0]?.bId, updates);
        console.log("QR Code response:", response);

        if (response.status === 200) {
          setError("QR code sent successfully!");
          setSelectedOption("Email")
          setEmailList("")
          setNumberList("")
          setCheckedOption(true)
          setBasicModal4(false);
          await trackButtonClick("MDetails", "Check-in_Qrcode", "staff", {});
        } else if (response.status === 403) {
          // Handle case when WhatsApp toggle is disabled  
          setError(`QR Code Template is not enabled for ${selectedOption}.`);

        } else if (response.status === 404) {
          console.error("Error sending QR code:", response);
          setError(response.message);

        } else {
          setError("Failed to send QR code. Try again later.");
        }
      } else {
        setError(`${selectedOption} field should not be empty`);
      }

    } catch (error) {
      console.error("Error during QR code request:", error);
      setError("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const thElements = document.querySelectorAll('.datatable-header th');

      thElements.forEach((th) => {
        if (th.textContent.trim().includes("Date")) {

          const icon = th.querySelector('i');
          if (icon) {
            icon.style.display = "none";
          }

          th.style.pointerEvents = "none";
          th.style.cursor = "default";
        }
      });
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);





  const onCancelHandler = () => {
    setSelectedOption("Email")
    setEmailList("")
    setNumberList("")
    setCheckedOption(true)
    setBasicModal4(false);
  }
  const handleViewQrCode = () => {
    setBasicModal5(true);
  }
  const onCancelQrcodeHandler = () => {

    setBasicModal5(false);
  }
  console.log(location.state, '99999999999999');

  // const handleQRDownload = async () => {
  //   if ((!location.state?.qrcheckinlink) && qrcodeUrl == null) {
  //     return
  //   }
  //   const memberName = location.state?.fname ? (location.state.fname + " " + location.state.lname).replace(/\s+/g, '_') : location.state.mid;
  //   const response = await downloadcheckinQrCode(
  //     JSON.parse(localStorage.getItem("loggedUserInfo"))
  //       ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
  //       : "",
  //     {
  //       mid: location.state._id,
  //       memberName: memberName,
  //       memberid: location.state.mid,
  //       url: qrcodeUrl,
  //       bid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
  //     }
  //   );

  //   const data = await response.json();
  //   console.log(data, "data");

  //   if (data.url) {
  //     const link = document.createElement("a");
  //     link.href = data.url;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // };

  const handleQRDownload = async () => {
    if ((!location.state?.qrcheckinlink) && qrcodeUrl == null) {
      return;
    }
    const memberName = location.state?.fname ? (location.state.fname + " " + location.state.lname).replace(/\s+/g, '_') : location.state.mid;
    const response = await downloadcheckinQrCode(
      JSON.parse(localStorage.getItem("loggedUserInfo"))
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        : "",
      {
        mid: location.state._id,
        memberName: memberName,
        memberid: location.state.mid,
        url: qrcodeUrl,
        bid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      }
    );

    const data = await response.json();
    console.log(data, "data");

    if (data.url) {

      const byteCharacters = atob(data.url.split(',')[1]);
      const byteArray = new Uint8Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([byteArray], { type: 'image/png' });


      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${memberName}_${location.state.mid}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const [historyData, setHistoryData] = useState({
    columns: [
      "S.no",
      "Pause Date",
      "Rusume Date",
      "Expiry Date",
      "Status"
    ],
    rows: [],
  });

  useEffect(() => {
    const popupRow = [];
    let snumber = 1;
    selectedTrans &&
      selectedTrans?.pause.length > 0 &&
      selectedTrans?.pause?.forEach((item, index) => {
        const rarray = [];
        rarray.push(snumber++);
        rarray.push(item.date ? formatDate(item.date) : "--");
        rarray.push(item?.fromtime ? formatDate(item.fromtime) : "--");
        rarray.push(item?.totime ? formatDate(item?.totime) : '--');
        rarray.push(item?.resume ? "Pause" : 'Resumed');
        popupRow.push(rarray);
      });

    setHistoryData((prev) => ({ ...prev, rows: popupRow }));

  }, [selectedTrans]);
  return (
    <>
      {apiError ? <PageError handleReload={handleReload} /> : <>
        <LeftPane isactive="150" />
        <Header />

        {location.state && <div className="gym-main gym-main-div rightContent">
          <div className="d-flex align-items-center justify-content-between w-100 flex-mob-col">
            <div className="d-flex align-items-center flex-mob-wrap justify-content-between w-100">
              <div className="d-flex align-items-center w-auto white-nowrap">
                <MDBIcon fas icon="arrow-left" className="fs-5" onClick={(e) => showInfo(e, location.state.return, { data: valuee })} />
                <h4 className="m-2 ms-4 title">
                  {location.state.fname} {location.state.lname}
                </h4>
              </div>
              <div className="d-flex align-items-center  w-100">

                <div className="d-flex align-items-center">
                  {(allData && allData.length > 0) && !allData[0].issuspend ?
                    <>
                      <div className="d-flex align-items-start">
                        {roleAccess?.editmember == 1 && <div className="ms-2">
                          <MDBBtn size='sm' className="btn btn-sm btn-secondary px-3" onClick={(e) => {
                            openEditForm(e)
                            setEditMembPopup((allData && allData.length > 0) ? allData[0] : location.state)
                          }}>
                            <MDBIcon far icon="edit" />
                          </MDBBtn>
                        </div>}
                        {allData.length > 0 && allData[0].trans.length > 0 && roleAccess?.checkin == 1 && <><div className="ms-2">
                          {(plansInfo !== null && plansInfo.feature.membercheckin) ?
                            <MDBBtn size='sm' className={allData.length > 0 && allData[0] ? (allData[0].checkinflag === 1 ? "btn btn-danger btn-sm me-2" : "btn btn-primary btn-sm me-2") :
                              (location.state && location.state.checkinflag === 1 ? "btn btn-danger" : "btn btn-primary")}
                              onClick={(e) => openLogTime(e, allData[0], allData[0].checkinflag === 1 ? "Check-Out" : "Check-In")}
                            >{allData.length > 0 && allData[0].checkinflag && allData[0].checkinflag === 1 ? "Check-Out" : "Check-In"}</MDBBtn>
                            : ""}
                        </div>
                          {roleAccess?.suspend == 1 && <button class="btn btn-danger btn-small ms-2" onClick={toggleOpen3}>suspend</button>}</>}
                      </div>
                    </>
                    : <>
                      <MDBBadge pill className='ms-4' color='danger' light>
                        Member Suspended
                      </MDBBadge>
                      {roleAccess?.suspend == 1 && <MDBBtn className="ms-2" onClick={toggleOpen}>Activate</MDBBtn>}
                    </>}

                  <div className="button-link link-color px-1">
                    <MDBBtn className="ms-2" onClick={() => handleQRcodepopup()}
                    // disabled={isButtonDisabled}
                    >Check-in QR Code</MDBBtn>
                  </div>

                </div>

                {roleAccess?.dnd == 1 && <div className="d-flex align-items-center mx-2">
                  <label className="mb-0 switchlabel">DND: </label>
                  <label className="switch">
                    <input className="form-control" type="checkbox" checked={DNDToggle} onChange={(e) => handleDNDToggle(e)} />
                    <span className="slider round"></span>
                  </label>
                </div>}
              </div>
            </div>
          </div>
          <div className="position-relative sm-mt ">
            <div className="userdetail_panel ">
              <div className="userleft">
                <div className="textsmal">
                  <label className="text-secondary">Member ID</label>
                  <h5 className="m-0">{location.state.mid ? location.state.mid : "N/A"}</h5>
                </div>
              </div>
              <div className="userright">
                <h6 className="m-0">{location.state.fname} {location.state.lname}</h6>
                <div className="d-flex flex-wrap">
                  <div className="detaillist">
                    <span>Gender</span>
                    <p className="m-0">{location.state.sex ? location.state.sex : "N/A"}</p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>Contact No</span>
                    <p className="m-0">{location.state.number ? location.state.number : "N/A"}</p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>E-mail Id</span>
                    <p className="m-0">{location.state.email ? location.state.email : "N/A"}</p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>Height</span>
                    <p className="m-0">{location.state.height}<span className="text-dark">{location.state.height ? "cms" : "N/A"}</span></p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>Weight</span>
                    <p className="m-0">{location.state.weight ? location.state.weight : ""} <span className="text-dark">{location.state.weight ? "kg" : "N/A"}</span></p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>Blood Group</span>
                    <p className="m-0">{location.state.bloodgroup ? location.state.bloodgroup : "N/A"}</p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>Country</span>
                    <p className="m-0">{location.state.country ? location.state.country : "N/A"}</p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>City</span>
                    <p className="m-0">{location.state.city ? location.state.city : "N/A"}</p>
                  </div>
                  <div className="split"></div>
                  <div className="detaillist">
                    <span>Address</span>
                    <p className="m-0">{location.state.address ? location.state.address : "N/A"}</p>
                  </div>


                </div>



                <div className="parallelogram"></div>
              </div>
            </div>
            {plansInfo != null && (plansInfo?.feature?.uploadlogo != false) &&
              <div className="userpicture">
                <img src={allData && allData.length > 0 && allData[0]?.imgurl ? allData[0].imgurl : defaultImg}
                  alt="Image" />
              </div>}
          </div>


          {/* <div className="usedetails">
            <div className="usedetails-data" >
              <MDBChip>
                <span className="me-1">Member Id: </span><b>{location.state.mid ? location.state.mid : "--"}</b>
              </MDBChip>
            </div>
            <div className="usedetails-data" >
              <MDBChip>
                <span className="me-1">Contact: </span><b>{location.state.number ? location.state.number : "--"}</b>
              </MDBChip>
            </div>
            <div className="usedetails-data" >
              <MDBChip>
                <span className="me-1">Gender: </span><b>{location.state.sex ? location.state.sex : "--"}</b>
              </MDBChip>
            </div>
            <div className="usedetails-data" >
              <MDBChip>
                <span className="me-1">Height: </span><b>{location.state.height}{location.state.height ? "cms" : "--"}</b>
              </MDBChip>
            </div>
            <div className="usedetails-data" >
              <MDBChip>
                <span className="me-1">Blood Group: </span><b>{location.state.bloodgroup ? location.state.bloodgroup : "--"}</b>
              </MDBChip>
            </div>

            <div className="usedetails-data" >
              <MDBChip>
              <span className="me-1">Email: </span><b>location.state.email ? location.state.email : "--"}</b>
              </MDBChip>
            </div>
          </div> */}
          <div className="usedetails">
            <div className="usedetails-data" >


              <span className="me-1">{membership.membershiptype === "addon" ? "Addon:" : "Plan:"}</span><b>

                {(() => {
                  const planItem = membership?.membershiptype ? membership : null;
                  const planDisplayName = planItem
                    ? (planItem.baseplan
                      ? `${BasePlanName(plans, membership.baseplan)} - ${membership.name}`
                      : planItem.name)
                    : "No Plan Associated";

                  return planDisplayName;
                })()}


                {(allData.length > 0 && !allData[0].issuspend && membership._id) && (
                  <>
                    <span >
                      <button
                        className={parseFloat(expiresin) > 6 ? "clr-green px-1 button-text" : [parseFloat(expiresin) > 0 ? "clr-orange button-text" : "clr-red button-text"]}
                        href="#"
                        onClick={() => {
                          const { planId, subplanId } = resolvePlanAndSubplan(membership, plans);

                          preaddUser({
                            member: location.state,
                            planId,
                            subplanId,
                          });
                        }}
                      >
                        ({expiresin})
                      </button>
                    </span>
                    <button className="button-link link-color px-1"
                      onClick={() => {
                        const { planId, subplanId } = resolvePlanAndSubplan(membership, plans);

                        preaddUser({
                          member: location.state,
                          planId,
                          subplanId,
                        });
                      }}
                    >
                      Renew
                    </button>
                  </>
                )}
              </b>
            </div>
            {/* {(allData && allData.length > 0) && !allData[0].suspend && LatestMTrans.length > 0
            && <MemberShipChange lastTras={LatestMTrans} details={location.state} />} */}
          </div>

          <MDBTabs className="mb-3">
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab1")}
                active={basicActive === "tab1"}
              >
                Plans
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab2")}
                active={basicActive === "tab2"}
              >
                Addons
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab3")}
                active={basicActive === "tab3"}
              >
                Payments/Transactions
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab4")}
                active={basicActive === "tab4"}
              >
                Attendance
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab5")}
                active={basicActive === "tab5"}
              >
                WhatsApp History
              </MDBTabsLink>
            </MDBTabsItem>

            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab6")}
                active={basicActive === "tab6"}
              >
                Guest Passes History
              </MDBTabsLink>
            </MDBTabsItem>

            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab7")}
                active={basicActive === "tab7"}
              >
                Session Sharing History
              </MDBTabsLink>
            </MDBTabsItem>

          </MDBTabs>
          <MDBTabsContent>
            <MDBTabsPane show={basicActive === "tab1"} open={basicActive === "tab1"}>
              <MDBDatatable className="sno plansTable scrool-table" fixedHeader data={mPData} entries={25} />
            </MDBTabsPane>
            <MDBTabsPane show={basicActive === "tab2"} open={basicActive === "tab2"}>
              <MDBDatatable className="sno addOnTable scrool-table" fixedHeader data={mAData} entries={25} />
            </MDBTabsPane>
            <MDBTabsPane show={basicActive === "tab3"} open={basicActive === "tab3"}>
              <MDBDatatable className="sno pymentsTable scrool-table" fixedHeader data={mPMData} entries={25} />
            </MDBTabsPane>
            <MDBTabsPane show={basicActive === "tab4"} open={basicActive === "tab4"}>
              <MDBDatatable className="sno scrool-table" fixedHeader data={mATData} entries={25} />
            </MDBTabsPane>
            <MDBTabsPane show={basicActive === "tab5"} open={basicActive === "tab5"}>
              <MDBDatatable className="sno whatsapphistorytable scrool-table" fixedHeader data={basicData} entries={25} />
            </MDBTabsPane>

            <MDBTabsPane show={basicActive === "tab6"} open={basicActive === "tab6"}>
              {loadingGuestPass ? (
                <div className="text-center p-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <MDBDatatable
                  className="sno guestPassTable scrool-table"
                  fixedHeader
                  data={guestPassHistory}
                  entries={25}
                />
              )}
            </MDBTabsPane>

            <MDBTabsPane show={basicActive === "tab7"} open={basicActive === "tab7"}>
              {loadingSessionSharing ? (
                <div className="text-center p-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <MDBDatatable
                  className="sno sessionSharingTable scrool-table"
                  fixedHeader
                  data={sessionSharingHistory}
                  entries={25}
                />
              )}
            </MDBTabsPane>


          </MDBTabsContent>
        </div>}
        {openPayment && (
          <Popup
            title="Payment Information"
            ptype="modal-lg"
            content={
              <>
                <div>
                  <Payments onsubmit={onPayemntDone} oncancel={oncancelpayment} handleTransdate={handleTransdate} />
                </div>
              </>
            }
            handleClose={oncancelpayment}
          />
        )}
        {openReceipt && (
          <Popup
            title="Print Receipt"
            ptype="modal-lg"
            content={
              <>
                <div>
                  <ReceiptPrint gotohome={gotohome} transactionDate={transDate} plansInfo={plans} />
                </div>
              </>
            }
            handleClose={gotohome}
          />
        )}
        {editTrans && (
          <Popup
            className="modal-body-overflow"
            title="Edit Membership Details "
            ptype="modal-md"
            style="overflow_inh"
            content={
              <>
                <EditMemberShip
                  editTrans={editTrans}
                  details={allData.length > 0 ? allData[0] : location.state}
                  session={sessionInfo.length > 0 ? sessionInfo.filter(item => item.transid === editTrans._id) : []}
                  guestpass={guestInfo?.filter(item => item.transid === editTrans._id) || []}
                  cancel={() => seteditTrans()}
                  onSuccess={(updatedMember) => {
                    setALLData([updatedMember]);

                    const updatedLocationState = {
                      ...location.state,
                      fname: updatedMember.fname || "",
                      lname: updatedMember.lname || "",
                      email: updatedMember.email || "",
                      number: updatedMember.number || "",
                      sex: updatedMember.sex || "",
                      height: updatedMember.height || "",
                      weight: updatedMember.weight || "",
                      bloodgroup: updatedMember.bloodgroup || "",
                      country: updatedMember.country || "",
                      city: updatedMember.city || "",
                      address: updatedMember.address || "",
                      isDND: updatedMember.isDND || false
                    };


                    navigate(location.pathname, {
                      state: updatedLocationState,
                      replace: true
                    });
                    seteditTrans(null);
                    setTimeout(() => {
                      fetchData();
                    }, 100);
                  }}

                  plans={plans}
                />
              </>
            }
            handleClose={seteditTrans}
          />
        )}
        {isTransOpen && (
          <Popup
            title="Transaction Details"
            content={
              <>
                <TransactionDetails
                  oncancel={closeTransPopup}
                  // onAssociate={openAUserPop}
                  id={tId}
                  gymid={localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1}
                  token={token}
                  Rtoken={Rid}
                  transid={transid}
                  from={"membership"}
                  filters={"mdetails"}
                />
              </>
            }
            handleClose={closeTransPopup}
          />
        )}
        {logtimeShow && (
          <SubPopup
            title={value !== null ? value : "Log Time"}
            ptype="modal-md"
            content={
              <>
                <div>

                  <LogATime
                    id={location.state?._id}
                    data={selData}
                    value={value}
                    guestpass={guestInfo?.filter(item => item.transid === selData?._id) || []}
                    oncancel={closeLogTime}
                    expires={
                      getExpiryDate(selData).includes("No Plan") ?
                        'No Plan Associated'
                        : getExpiryDate(selData).includes('Expired (Overdue)')
                          ? 'Expired (Overdue)'
                          : getExpiryDate(selData).includes('Expired')
                            ? 'Expired'
                            : `Expires: ${getExpiryDate(selData)}`
                    }
                    onsave={checkMember}
                  />
                </div>
              </>
            }
            handleClose={closeLogTime}
          />
        )
        }
        {isOpen && (
          <Popup
            title="Add Member"
            ptype="modal-lg"
            className="modal-body-overflow"
            content={
              <>
                <div className="modal-body-overflow">
                  <CreateMember
                    id={null}
                    index={null}
                    onsubmit={onsubmit}
                    backallback={createMemberCallback}
                    submit="0"
                    mId={mId}
                    // addandSave={addandSave}
                    from={"memberdetails"}
                    path={"membership"}
                    gymid={JSON.parse(localStorage.getItem("loggedUserInfo")).gymid}

                  />
                </div>
              </>
            }
            handleClose={togglePopup}
          />
        )
        }

        {location.state && <>
          <MDBModal tabIndex='-1' open={centredModal} setOpen={setCentredModal}>
            <MDBModalDialog centered>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Activate Member</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                  <label>
                    <b className="title">{location.state.fname + " " + location.state.lname}</b>
                    {location.state.number ? (", " + location.state.number) : ""}{location.state.age ? (", " + location.state.age + "y") : ""}
                  </label>
                  <p className="mt-2">This Member will be <strong>Activated</strong> again. Are you sure you want to activate this account?</p>
                </MDBModalBody>
                <MDBModalFooter className="pe-2 pb-2">
                  <MDBBtn color='secondary' onClick={toggleOpen}>Cancel</MDBBtn>
                  <MDBBtn onClick={activateFunction}>Activate</MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>

          <MDBModal open={basicModal3} setOpen={setBasicModal3} tabIndex='-1'>
            <MDBModalDialog>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Suspend</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={toggleOpen3}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody className="overflow_inh">
                  <div>
                    <label>
                      <b className="title">{location.state.fname + " " + location.state.lname}</b>
                      {location.state.number ? (", " + location.state.number) : ""}{location.state.age ? (", " + location.state.age + "y") : ""}
                    </label>
                    <p className="my-2">This action will deactivate this member. Are you sure you want to <strong>suspend</strong>?</p>
                    <label className="fw-bold">Reason</label>
                    <MDBTextArea id='textAreaExample' rows={3} onChange={(e) => handlerReason(e)} />
                    {errors !== "" && <p className="clr-red">{errors}</p>}
                  </div>
                </MDBModalBody>
                <MDBModalFooter className="pe-3 pb-2">
                  <MDBBtn color='secondary' onClick={toggleOpen3}>
                    Cancel
                  </MDBBtn>
                  <MDBBtn color="danger" onClick={(e) => suspendSubmitFunction(e)}>Suspend</MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>


          <MDBModal open={basicModal4} setOpen={setBasicModal4} tabIndex='-1'>
            <MDBModalDialog>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Check-in QR Code</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={onCancelHandler}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody className="overflow_inh">
                  <div className="d-flex align-items-center">
                    <MDBRadio
                      name="inlineRadio"
                      id="inlineRadio1"
                      value="Email"
                      label="Email"
                      inline
                      checked={selectedOption === "Email"}
                      onChange={(e) => setSelectedOption(e.target.value)}
                    />
                    <MDBRadio
                      name="inlineRadio"
                      id="inlineRadio2"
                      value="Whatsapp"
                      label="Whatsapp"
                      inline
                      checked={selectedOption === "Whatsapp"}
                      onChange={(e) => setSelectedOption(e.target.value)}
                    />
                    {/* <MDBRadio
                      name="inlineRadio"
                      id="inlineRadio3"
                      value="SMS"
                      label="SMS"
                      inline
                      checked={selectedOption === "SMS"}
                      onChange={(e) => setSelectedOption(e.target.value)}
                    /> */}
                  </div>



                  {selectedOption === "Email" ? (
                    <div>
                      {allData?.[0]?.email != "" ? <MDBCheckbox
                        id="flexCheckDefault12"
                        label={allData?.[0]?.email || "N/A"}
                        checked={checkedOption}
                        onChange={(e) => setCheckedOption(!checkedOption)}
                      /> : <></>}
                    </div>
                  ) : (
                    <div>
                      {allData?.[0]?.number != "" ? <MDBCheckbox
                        id="flexCheckDefault2"
                        label={allData?.[0]?.number || "N/A"}
                        checked={checkedOption}
                        onChange={(e) => setCheckedOption(!checkedOption)}
                      /> : <></>}
                    </div>
                  )}


                  <div className="mt-2">
                    <label>Enter other</label>
                    <MDBInput
                      type="text"
                      placeholder={
                        selectedOption === "Email"
                          ? "Enter additional emails (comma-separated)"
                          : "Enter additional numbers (comma-separated)"
                      }
                      value={selectedOption === "Email" ? emailList : numberList}
                      onChange={(e) =>
                        selectedOption === "Email"
                          ? setEmailList(e.target.value)
                          : setNumberList(e.target.value)
                      }
                    />
                    <p className="text-secondary m-0 mt-2">
                      Note: To enter multiple, use comma (,) separated values.
                    </p>
                  </div>

                </MDBModalBody>
                <MDBModalFooter className="pe-3 pb-2">
                  <div className="d-flex w-100 justify-content-between">
                    <div className="d-flex align-items-center">
                      <MDBBtn className="ms-2" onClick={handleViewQrCode}>View QR Code</MDBBtn>
                    </div>

                    <div className="d-flex align-items-center">
                      <MDBBtn color="secondary" onClick={onCancelHandler}>
                        Cancel
                      </MDBBtn>
                      <MDBBtn onClick={handleQrCode} className="ms-2">Send</MDBBtn>
                    </div>
                  </div>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>

          <MDBModal open={basicModal5} setOpen={setBasicModal5} tabIndex='-1'>
            <MDBModalDialog>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Check-in QR Code</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={onCancelQrcodeHandler}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody className="overflow_inh">
                  <div className="d-flex align-items-center justify-content-center w-100">
                    {(qrcodeUrl !== null || location.state?.qrcheckinlink) ? <img
                      src={qrcodeUrl != null ? `${qrcodeUrl}` : location.state.qrcheckinlink}
                      alt="QR Code"
                      // style={{ maxWidth: '100%', height: 'auto' }}
                      style={{ width: '300px', height: '300px' }}
                    /> : <span>No Qrcode found</span>}
                  </div>
                </MDBModalBody>
                <MDBModalFooter className="pe-3 pb-2">
                  <div className="d-flex w-100 justify-content-between">
                    <div className="d-flex align-items-center">
                      <MDBBtn className="ms-2" onClick={handleQRDownload}>Download</MDBBtn>
                    </div>

                    <div className="d-flex align-items-center">
                      <MDBBtn color="secondary" onClick={onCancelQrcodeHandler}>
                        Cancel
                      </MDBBtn>

                    </div>
                  </div>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
          {error && (
            <MDBAlert
              color={
                error.includes("QR code sent successfully!") || error.includes("Member Updated Successfully") ||error.includes("changed successfully!")
                  ? "success"
                  : "danger"
              }
              autohide
              position='top-right'
              delay={5000}
              appendToBody
              open={error !== ""}
              onClose={() => setError("")}
            >
              {error}
            </MDBAlert>

          )}
        </>}

      </>}

      <MDBModal open={historyPopup} setOpen={SetHistoryPopup} tabIndex='-1'>
        <MDBModalDialog size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Membership History</MDBModalTitle>
              <MDBBtn className='btn-close' color='none'
                onClick={() => { SetHistoryPopup(false); }}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBDatatable entries={25} data={historyData} pagination={false} className="SuscriptionHistoryDataTable" />
            </MDBModalBody>
            <MDBModalFooter className="pb-2 pe-3">

              <MDBBtn color='secondary'
                onClick={() => { SetHistoryPopup(false); }}
              >
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>

      </MDBModal>



{showChangePlan && (
  <ChangePlanModal
    open={showChangePlan}
    setOpen={setShowChangePlan}
    member={location.state}
    currentTransaction={selectedMemberData}
    plans={allPlans}
    addons={allAddons}
    businessTax={businessTax}
    changeType={changeType}  // Pass the change type
    onSuccess={(updatedData) => {
      fetchData();
      setError(`${changeType === "addon" ? "Addon" : "Plan"} changed successfully!`);
    }}
  />
)}
    </>
  );
}

